module.exports = __webpack_public_path__ + "static/media/banner002-a.1fc6bb9d.jpg";